import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const tooltipStyle = {
  borderRadius: '8px',
  border: 'none',
  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  fontSize: '12px',
};

const WeeklyActivityChart = ({ allData }) => {
  const weekMap = {};
  (allData || []).forEach(r => {
    const w = r.weekNumber;
    if (!weekMap[w]) {
      weekMap[w] = { week: `Wk ${w}`, screeningCalls: 0, passedAfterScreening: 0, finalStages: 0, offersAccepted: 0 };
    }
    weekMap[w].screeningCalls += r.screeningCalls || 0;
    weekMap[w].passedAfterScreening += r.passedAfterScreening || 0;
    weekMap[w].finalStages += r.finalStages || 0;
    weekMap[w].offersAccepted += r.offersAccepted || 0;
  });

  const chartData = Object.values(weekMap).sort((a, b) => {
    return parseInt(a.week.replace('Wk ', '')) - parseInt(b.week.replace('Wk ', ''));
  });

  return (
    <div className="dashboard-card p-6 slide-in-up">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-lg font-semibold text-gray-800">Weekly Activity Trends</h3>
        <div className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-1 rounded-full">
          Filtered Data
        </div>
      </div>
      <p className="text-sm text-gray-600 mb-4">Screening calls, passed candidates, final stages &amp; offers for selected filters</p>
      {chartData.length === 0 ? (
        <div className="flex items-center justify-center h-48 text-gray-400 text-sm">No data available</div>
      ) : (
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={chartData} margin={{ top: 4, right: 16, left: 0, bottom: 4 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="week" tickLine={false} axisLine={false} style={{ fontSize: '12px' }} />
            <YAxis tickLine={false} axisLine={false} style={{ fontSize: '12px' }} allowDecimals={false} />
            <Tooltip contentStyle={tooltipStyle} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Line type="monotone" dataKey="screeningCalls" name="Screening Calls" stroke="#4841F0" strokeWidth={2} dot={{ r: 3 }} />
            <Line type="monotone" dataKey="passedAfterScreening" name="Passed Screening" stroke="#6366f1" strokeWidth={2} dot={{ r: 3 }} />
            <Line type="monotone" dataKey="finalStages" name="Final Stages" stroke="#8b5cf6" strokeWidth={2} dot={{ r: 3 }} />
            <Line type="monotone" dataKey="offersAccepted" name="Offers Accepted" stroke="#10b981" strokeWidth={2} dot={{ r: 3 }} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default WeeklyActivityChart;
